import { render, staticRenderFns } from "./fuTrade.vue?vue&type=template&id=05ce0be0&scoped=true"
import script from "./fuTrade.vue?vue&type=script&lang=js"
export * from "./fuTrade.vue?vue&type=script&lang=js"
import style0 from "./fuTrade.vue?vue&type=style&index=0&id=05ce0be0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ce0be0",
  null
  
)

export default component.exports